import { Assets } from 'pixi.js';
import { createRoot } from 'react-dom/client';
import App from './app/App';
import R2Harness from './app/R2Harness';
import { isR2HarnessRequested } from './game/render/r2/flag';

// Pixi's worker-based ImageBitmap support probe resolves only on a worker
// message and has no error path: hosts whose CSP blocks fetches inside blob
// workers (e.g. the sandbox deploy target) leave Assets.load awaiting forever
// before a single texture request goes out. Main-thread decoding works
// everywhere, so opt out of the probe entirely.
Assets.setPreferences({ preferWorkers: false });

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');
// ?r2=harness is the asset harness; ?r2=1 is the game itself on the R2
// renderer, which App picks up through GameRuntime's own flag read.
createRoot(root).render(isR2HarnessRequested() ? <R2Harness /> : <App />);
